module.exports = __webpack_public_path__ + "img/list1.3f3bb997.jpg";